<template>
  <p v-if="message" :class="getBackgroungClass()">
    {{ message }}
  </p>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Messages",
  props: {},
  components: {},
  data(){
    return{
      message: ''
    }
  },
  methods: {
    ...mapMutations([
        'setMessageApp',
        'setStatusMessage',
    ]),
    ...mapActions([]),
    getBackgroungClass(){
      switch (this.getStatusMessage){
        case 'reussite': return 'bg-success'
        case 'echec': return 'bg-danger'
        case 'info': return 'bg-info'
        case 'warning': return 'bg-warning'
        case 'secondary': return 'bg-secondary'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getMessageApp',
      'getStatusMessage',
      'getTimeoutMessage',
    ]),
  },
  watch: {
    message: function () {
      let vm = this
      setTimeout( () => {
        vm.message = ''; vm.setMessageApp(null); vm.setStatusMessage(null)
      }, vm.getTimeoutMessage)
    },
    getMessageApp() {
      let vm = this; vm.message = vm.getMessageApp
    }
  },
  beforeCreate() {},
  created() {
    this.message = this.getMessageApp
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
p{
  position: relative;
  padding: .5rem 1rem;
  color: var(--color-second);
  text-align: center;
  margin-bottom: 0;
  width: 100%;
  background: var(--color-fifth);
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Messages.vue